import { Action } from './actions';

export const defaultState = {
  canRenew: false,
  canSwitch: false,
  instrumentId: undefined,
  isOverdue: false,
  isRenewing: false,
  isSwitching: false,
  reshipped: false,
  shipDate: undefined,
  wasRenewed: false,
  wasSwitched: false,
  wasReshipped: false,
  wasReturned: false,
  requiresConfirmation: false,
};

export default function payCardReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case Action.Renew.RenewCardPending:
      return {
        ...state,
        isRenewing: true,
      };

    case Action.Renew.RenewCardFailed:
      return {
        ...state,
        error: action.payload,
        isRenewing: false,
      };

    case Action.Renew.RenewCardCompleted:
      return {
        ...state,
        isOverdue: false,
        isRenewing: false,
        wasRenewed: true,
      };

    case Action.Reship.ReshipCardCompleted:
      return {
        ...state,
        isOverdue: false,
        wasReshipped: true,
        requiresConfirmation: action.payload?.requiresConfirmation,
      };

    case Action.Switch.RequestNewProgramCardPending:
      return {
        ...state,
        isSwitching: true,
      };

    case Action.Switch.RequestNewProgramCardFailed:
      return {
        ...state,
        error: action.payload,
        isSwitching: false,
      };

    case Action.Switch.RequestNewProgramCardCompleted:
      return {
        ...state,
        isSwitching: false,
        wasSwitched: true,
      };

    default:
      return state;
  }
}
